export const useAppLocale = () => {
  const i18n = useI18n();

  const locale = computed(() => i18n.locale.value);
  const lang = computed(() => locale.value);

  const currentLocale = computed(() => {
    return i18n.locales.value.find((localeOption) => {
      return (
        typeof localeOption !== 'string' && localeOption.code === locale.value
      );
    });
  });

  const dir = computed<'ltr' | 'rtl'>(() =>
    currentLocale.value?.dir === 'rtl' ? 'rtl' : 'ltr'
  );

  const isRtl = computed(() => dir.value === 'rtl');

  return {
    currentLocale,
    locale,
    isRtl,
    lang,
    dir,
  };
};
